import * as React from 'react';

interface Props {
  shippingLine: string;
  containerType: string;
  currentTime: string;
}

export const Title: React.FC<Props> = (props) => {
  const { shippingLine, containerType, currentTime } = props;

  if (!shippingLine && !containerType) {
    return null;
  }

  return (
    <div className="flex space-x-4 items-center">
      <h3 className="font-medium text-dark">Next available appointments for </h3>
      <div className="px-4 py-2 font-bold text-white bg-legacyBlue rounded-full">
        <h4>{shippingLine}</h4>
      </div>
      <div className="px-4 py-2 font-bold text-white bg-legacyBlue rounded-full">
        {containerType ? <h4>{containerType}</h4> : null}
      </div>
      <h3 className="font-medium text-dark">as of</h3>
      <div className="px-4 py-2 font-bold text-white bg-legacyBlue rounded-full">
        <h4>{currentTime}</h4>
      </div>
    </div>
  );
};
Title.displayName = 'T_Appointments.TableHeader.Title';
